import React, { useState, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';
import { AuthContext } from '@ts/commons/AuthProvider';
import Loader from '@ts/ui/Loader';
import logo from '../../images/logotype-big.svg';
import FederationContainer from './FederationContainer';
import { forms, components } from './data';
import * as S from './styles';

function Authentication() {
    const context = React.useContext(AuthContext);
    const [activeForm, setActiveForm] = useState(forms.signin);
    const Component = components[activeForm];

    const signOut = useCallback((e) => {
        e.preventDefault();
        Auth.signOut({ global: false });
    }, []);

    return (
        <S.PageContainer>
            <S.Wrapper>
                <S.Container>
                    <S.Head>
                        <Link to="/">
                            <center>
                                <img src={logo} alt="tripshock logo" />
                            </center>
                        </Link>
                    </S.Head>

                    {context.loading ? (
                        <div style={{ padding: 10 }}>
                            <Loader />
                        </div>
                    ) : (
                        <React.Fragment>
                            {!context.user ? (
                                <S.InnerContainer>
                                    <FederationContainer />
                                    <S.Divider>
                                        <hr />
                                        <span>or</span>
                                    </S.Divider>
                                    <Component setActiveForm={setActiveForm} />
                                </S.InnerContainer>
                            ) : (
                                <React.Fragment>
                                    <S.Actions>
                                        <S.ActionButton onClick={signOut}>Sign Out</S.ActionButton>
                                        <S.ActionButton
                                            onClick={() => {
                                                window.location = '/';
                                            }}
                                        >
                                            Back to page
                                        </S.ActionButton>
                                    </S.Actions>
                                    <S.InnerContainer>
                                        <S.Greeting>
                                            Welcome to TripShock
                                            {context.user.attributes && (
                                                <span>
                                                    ,{' '}
                                                    <span>
                                                        {context.user.attributes.given_name}
                                                    </span>
                                                </span>
                                            )}
                                            !
                                        </S.Greeting>
                                    </S.InnerContainer>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </S.Container>
            </S.Wrapper>
        </S.PageContainer>
    );
}

export default Authentication;
